//**auto-generated don't edit this code**//
export enum StudentLunchStatus {
	Free,
	Reduced,
	Other,
}